import axios from 'axios'
import _ from 'lodash'
import * as Sentry from '@sentry/browser'
import { toast } from 'react-toastify'

const isNetworkError = (err) => {
  return !!err.isAxiosError && !err.response
}

axios.interceptors.response.use((response) => {
  return response
}, (err) => {
  Sentry.captureException(err)
  console.log(err)
  const status = _.get(err, 'response.status') || err.status
  const statusMsg = status ? `${status}: ` : ''
  if (isNetworkError(err))
    toast.error(`${statusMsg}Problema na solicitação: ${err.message}`)

  return Promise.reject(err)
})

export { axios as default }
